<template>
  <div>
    <div :class="isShowContact? 'contact-shadow fixed-wrap' : ''"></div>
    <div class="wrap">
      <!-- 自定义导航栏 -->
      <Nav></Nav>
      <!-- 自定义导航栏 -->
      <!--poster-->
      <div class="poster-wrap">
        <div class="poster-box">
          <div class="poster-margin">
            <div class="poster-div">
              <div class="poster-title">2020年最火爆的微商项目</div>
              <div class="scan">扫码加入</div>
              <div class="line"></div>
              <div class="qrcode-box">
                <div class="qrcode-div">
                  <div class="qrcode-img-div">
                    <img src="../../../../assets/img/official/mini_progrom.jpg" alt="">
                  </div>
                  <div>购票体验小程序</div>
                </div>
                <div class="qrcode-div">
                  <div class="qrcode-img-div">
                    <img :src="wechat_code" alt="">
                  </div>
                  <div>联系客服</div>
                </div>
              </div>
              <div class="login-box">
                <span class="login-btn" @click="toLogin">入驻/登录</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- poster -->
      <!-- 我们的优势 -->
      <div class="advantage-wrap">
        <div class="advantage-box">
          <div class="module-title">我们的优势</div>
          <div class="module-en-title">Our strengths</div>
          <div class="padding-t-30">
            <el-row>
              <el-col :span="12">
                <div class="padding-left">
                  <div class="adv-box">
                    <div class="adv-img">平台优势</div>
                    <div class="adv-content" ref="advantage_box">
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">全国影院覆盖，在线选座，在线购票；</div>
                      </div>
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">系统全自动出票，售后少，回购高，省时省力；</div>
                      </div>
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">多种出票模式，满足不同用户需求</div>
                      </div>
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">用户购票价格对标猫眼淘票票3~9折；</div>
                      </div>
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">总利润不低于售价的8%（秒出票除外），利润率可观；</div>
                      </div>
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">对接渠道多样化，社群，公众号，小程序，app皆可对接；</div>
                      </div>
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">无需服务器，域名，对接流程简捷，5分钟上线</div>
                      </div>
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">多对一专属服务；</div>
                      </div>
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">持续更新新功能附加服务</div>
                      </div>
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">佣金提现快，无门槛</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="padding-right">
                  <div class="adv-box">
                    <div class="adv-img">项目优势</div>
                    <div class="adv-content" :style="{height:advantageHeight}">
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">易推广裂变，用户粘性高</div>
                      </div>
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">易推广裂变，用户粘性高</div>
                      </div>
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">市场空间大，竞争强度低</div>
                      </div>
                      <div class="scene">支付对接的场景</div>
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">微信公众号</div>
                      </div>
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">小程序</div>
                      </div>
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">社群</div>
                      </div>
                      <div class="adv-part-box">
                        <div class="adv-part-rhombus"></div>
                        <div class="adv-part-content">APP</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 我们的优势 -->
      <!-- 版本对比 -->
      <div class="version-wrap">
        <div class="version-box">
          <div class="module-title">版本功能对比</div>
          <div class="module-en-title">Version function comparison</div>
          <div class="padding-t-30">
            <el-row>
              <el-col :span="12">
                <div class="padding-left">
                  <div class="ver-box">
                    <div class="ver-img">
                      <div class="ver-info">
                        <div class="ver-title">基础版</div>
                        <div><span class="ver-money">99-699</span>元/年</div>
                      </div>
                    </div>
                    <div class="ver-scope">
                      <div class="scope-title">服务范围</div>
                      <div class="padding-15">
                        <el-row>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>获取全国影院信息</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>获取最新影片信息</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>获取即将上映影片信息</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>秒出票功能</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>特惠购票功能</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>竞价购票功能</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>无限制推送商品消息</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>绑定小程序</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>订单报表</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>推广素材库</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>会员系统</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box color-c1">
                              <img src="../../../../assets/img/official/home_icon_cancel.png" alt="">
                              <div>粉丝维度模块</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box color-c1">
                              <img src="../../../../assets/img/official/home_icon_cancel.png" alt="">
                              <div>用户裂变模块</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box color-c1">
                              <img src="../../../../assets/img/official/home_icon_cancel.png" alt="">
                              <div>自定义域名</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box color-c1">
                              <img src="../../../../assets/img/official/home_icon_cancel.png" alt="">
                              <div>自定义消息回复</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box color-c1">
                              <img src="../../../../assets/img/official/home_icon_cancel.png" alt="">
                              <div>自定义邀请海报</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box color-c1">
                              <img src="../../../../assets/img/official/home_icon_cancel.png" alt="">
                              <div>所有辅助软件</div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="padding-right">
                  <div class="ver-box">
                    <div class="ver-img">
                      <div class="ver-info">
                        <div class="ver-title">分销</div>
                        <div><span class="ver-money">2699</span>元/年</div>
                      </div>
                    </div>
                    <div class="ver-scope">
                      <div class="scope-title">服务范围</div>
                      <div class="padding-15">
                        <el-row>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>获取全国影院信息</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>获取最新影片信息</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>获取即将上映影片信息</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>秒出票功能</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>特惠购票功能</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>竞价购票功能</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>无限制推送商品消息</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>绑定小程序</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>订单报表</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>推广素材库</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>会员系统</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>粉丝维度模块</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>用户裂变模块</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>自定义域名</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>自定义消息回复</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>自定义邀请海报</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="scope-box">
                              <img src="../../../../assets/img/official/home_icon_tick.png" alt="">
                              <div>所有辅助软件</div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 版本对比 -->
      <!-- 支付对接场景 -->
      <div class="pay-scene-wrap">
        <div class="scene-box">
          <div class="scene-margin">
            <div class="scene-div">
              <div class="scene-title">支付对接的场景</div>
              <div class="color-333 font-20">微信公众号、小程序、社群、APP</div>
              <div class="color-333 padding-t-30 padding-b-15 font-24">功能说明</div>
              <div class="color-666 font-15">在线购票  快速变形</div>
              <div class="color-666 font-15 padding-t-8">收益可观  加盟简单</div>
              <div class="more">
                <span class="more-btn">联系客服了解更多</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 支付对接场景 -->
      <Footer></Footer>
      <div style="display: none;" id="open-new">
        <router-link tag="div" to="/pc/official/activation">
          <a target="_blank"></a>
        </router-link>
      </div>
      <div style="display: none;" id="to-stat">
        <router-link tag="div" to="/pc/official/statistics">
          <a target="_blank"></a>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import Nav from '@/components/Nav.vue'
  import Footer from '@/components/Footer.vue'
  import { getToken, getIsBasic, getHasPackage } from '@/utils/auth'
  import { login, getServerConfig } from '@/api/user'
  import { Modal } from 'view-design'
  export default {
    name: 'Home',
    components: {
      Nav,
      Footer,
      Modal
    },
    data() {
      return {
        advantageHeight: 0,
        nickname: '',
        password: '',
        code: '',
        loading: false,
        isAutoSwiper: true,
        isLogin: getToken() ? true : false, //是否登录
        isShowContact: false,
        wechat_code: '',
        hasPackage:getHasPackage() === 'true' ? true : false,
      }
    },
    computed: {
    },
    mounted: function() {
      var that = this
      that.getAdvantageBoxHeight();
      that.loading = true
      getServerConfig().then(response => {
        that.loading = false
        that.wechat_code = response.data.wechat_code
      }).catch(error => {
        that.loading = false
        console.log(error)
        that.$Message.error('加载客服信息失败,请稍后再试!')
      })
    },
    methods: {
      getAdvantageBoxHeight: function() {
        this.advantageHeight = this.$refs.advantage_box.offsetHeight + 'px'
      },
      toLogin(){
        var that = this
        var token = getToken()
        if (token === undefined || token === '') {
          that.$store.dispatch('nav/changeActiveIndex', 0)
          that.$store.dispatch('nav/changeIsGoOfficial', 1)
          that.$router.push('/pc/home')
        }else{
          that.hasPackage = getHasPackage() === 'true' ? true : false
          if(that.hasPackage === false){
            var that = this;
            //未开通套餐时，点击任何菜单都是跳转到激活续费页面
            // 弹窗提示
              that.$store.dispatch('official/changeIsShowSlide', true)
              // window.open('#/pc/official/dialog','_brank')
              let targetDiv = document.getElementById('open-new')
              targetDiv.getElementsByTagName('a')[0].click()
          }else{
            that.$store.dispatch('official/changeIsShowSlide', true)
            //that.$router.push('/pc/official/statistics').catch(err => { err })
            let targetDiv = document.getElementById('to-stat')
            targetDiv.getElementsByTagName('a')[0].click()
          }
        }
      }
    },
  }
</script>

<style lang="less" scoped>
  .fixed-wrap {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .wrap {
    min-width: 850px;
    /* 海报 */
    .poster-wrap {
      //min-height: 360px;
      min-height: 580px;
      background-image: url(../../../../assets/img/official/ruzhu_bg_poster.png);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50% 50%;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-wrap: nowrap;
      position: relative;
      color: #FFFFFF;
      .poster-box {
        width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        .poster-div {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .poster-title{
            font-size: 42px;
            font-family: Alibaba-PuHuiTi-M;
          }
          .scan{
            font-size: 18px;
            padding: 10px 0 30px 0;
          }
          .line{
            width: 40px;
            height: 4px;
            background: #FF9734;
          }
          .qrcode-box{
            padding-top: 22px;
            display: flex;
            flex-direction: row;
            .qrcode-div{
              padding-right: 24px;
              .qrcode-img-div{
                padding: 6px;
                background: #FFFFFF;
                img{
                  height: 160px;
                }
              }
              div{
                padding-top:10px;
              }
            }
          }
          .login-box{
            padding-top: 40px;
            .login-btn{
              cursor: pointer;
              padding: 10px 60px;
              background: #FF9734;
              line-height: 24px;
              text-align: center;
              font-size: 15px;
            }
          }
        }
      }
    }
    /* 海报*/
    /* 我们的优势*/
    .advantage-wrap{
      background: #FAFAFA;
      font-size: 14px;
      color: #666666;
      .advantage-box{
        padding: 100px 0;
        .padding-left{
          padding-right: 30px;
          .adv-img{
          -image: url(../../../../assets/img/official/ruzhu_img_platform.png);
          }
        }
        .padding-right{
          padding-left: 30px;
          .adv-img{
            background-image: url(../../../../assets/img/official/ruzhu_img_project.png);
          }
        }
        .adv-box{
          background: #FFFFFF;
          box-shadow: 0 0 8px 0 rgba(0,0,0,0.06);
          .adv-img{
            font-family: Alibaba-PuHuiTi-M;
            font-size: 26px;
            height: 225px;
            color: #FFFFFF;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: 50% 50%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
          }
        }
        .adv-content{
          padding: 30px 30px 40px 30px;
          .adv-part-box {
            display: flex;
            flex-direction: row;
            padding: 5px 0;
            .adv-part-rhombus {
              width: 6px;
              height: 6px;
              background: #ff9734;
              transform: rotate(45deg);
              margin: 5px 10px 5px 5px;
            }
            .adv-part-content {
              width: 90%;
            }
          }
          .scene{
            color: #222222;
            font-size: 18px;
            padding: 15px 0 8px 0;
          }
        }
      }
    }
    /* 我们的优势*/
    /* 版本对比*/
    .version-wrap{
      background: #FFFFFF;
      .version-box{
        padding: 100px 0;
        .padding-left{
          padding-right: 30px;
          .ver-img{
            background-image: url(../../../../assets/img/official/ruzhu_bg_basicversion.png);
          }
        }
        .padding-right{
          padding-left: 30px;
          .ver-img{
            background-image: url(../../../../assets/img/official/ruzhu_bg_fenxiao.png);
          }
        }
        .ver-box{
          background: #FFFFFF;
          box-shadow: 0 0 8px 0 rgba(0,0,0,0.06);
          .ver-img{
            font-family: Alibaba-PuHuiTi-M;
            font-size: 26px;
            height: 180px;
            color: #FFFFFF;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: 50% 50%;
            .ver-info{
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              height: 160px;
              font-family: Alibaba-PuHuiTi-R;
              font-size: 14px;
              .ver-title{
                font-family: Alibaba-PuHuiTi-M;
                font-size: 26px;
              }
              .ver-money{
                font-family: Alibaba-PuHuiTi-M;
                font-size: 26px;
              }
            }
          }
          .ver-scope{
            font-size: 14px;
            color: #222222;
            .scope-title{
              font-family: Alibaba-PuHuiTi-M;
              color: #666666;
              font-size: 26px;
              text-align: center;
              padding-bottom: 5px;
            }
            .scope-box{
              display: flex;
              flex-direction: row;
              align-items: center;
              height: 45px;
              img{
                height: 16px;
                margin-right: 8px;
              }
            }
          }
        }
      }
    }
    /* 版本对比*/
    /* 支付场景*/
    .pay-scene-wrap{
      height: 600px;
      background-image: url(../../../../assets/img/official/ruzhu_bg_pagedisplay.png);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50% 50%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-wrap: nowrap;
      .scene-box {
        width: 100%;
        .scene-div {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .scene-title{
            font-size: 42px;
            color: #191919;
            padding-bottom: 10px;
            font-family: Alibaba-PuHuiTi-M;
          }
          .more{
            padding-top: 25px;
            margin-bottom: 39px;
            .more-btn{
              padding: 8px 22px;
              background: #FF8622;
              color: #FFFFFF;
              text-align: center;
            }
          }
        }
      }

    }
    /* 支付场景*/
  }
  .module-title{
    font-family: Alibaba-PuHuiTi-M;
    font-size: 32px;
    color: #222222;
    text-align: center;
    padding-bottom: 8px;
  }
  .module-en-title{
    font-size: 16px;
    color: #666666;
    text-align: center;
    padding-bottom: 30px;
  }
  /* 底部*/
  @media (min-width: 768px) {
    .poster-wrap .poster-margin,
    .advantage-wrap .advantage-box,
    .version-wrap .version-box,
    .pay-scene-wrap .scene-box{
      margin: auto 7.5%;
    }
  }

  @media (min-width: 992px) {
    .poster-wrap .poster-margin,
    .advantage-wrap .advantage-box,
    .version-wrap .version-box,
    .pay-scene-wrap .scene-box{
      margin: auto 10%;
    }
  }

  @media (min-width: 1200px) {
    .poster-wrap .poster-margin,
    .advantage-wrap .advantage-box,
    .version-wrap .version-box,
    .pay-scene-wrap .scene-box{
      margin: auto 15%;
    }
  }

  @media (min-width: 1400px) {
    .poster-wrap .poster-margin,
    .advantage-wrap .advantage-box,
    .version-wrap .version-box,
    .pay-scene-wrap .scene-box{
      margin: auto 18.75%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/official/home/Index.vue